/* eslint-disable no-useless-escape */

import * as yup from 'yup';

export const validationSchema = yup.object({
    fieldModule: yup
        .string()
        .required('Required'),
    fieldRef: yup
        .string()
        .required('Required'),
    fieldKey: yup
        .string()
        .required('Required'),
    fieldType: yup
        .string()
        .required('Required'),
})

export const initialValues = {
    fieldModule: "",
    fieldRef: "",
    fieldKey: "",
    fieldType: "",
}
